module.exports = __webpack_public_path__ + "img/defaultAvatar.cb2becca.png";